var React = require('react');

function MapMarker (props) {
    return React.createElement("svg",props,[React.createElement("path",{"opacity":"0.4","d":"M7.05198 0C3.15324 0 0 3.09881 0 6.93024C0 12.1279 7.05198 19.8007 7.05198 19.8007C7.05198 19.8007 14.104 12.1279 14.104 6.93024C14.104 3.09881 10.9507 0 7.05198 0ZM2.01485 6.93024C2.01485 4.19774 4.27148 1.98007 7.05198 1.98007C9.83247 1.98007 12.0891 4.19774 12.0891 6.93024C12.0891 9.78153 9.18772 14.0486 7.05198 16.7118C4.95653 14.0684 2.01485 9.75183 2.01485 6.93024Z","fill":"#50606C","key":0}),React.createElement("path",{"opacity":"0.4","d":"M7.05199 9.40532C8.44295 9.40532 9.57056 8.29719 9.57056 6.93024C9.57056 5.56329 8.44295 4.45515 7.05199 4.45515C5.66102 4.45515 4.53342 5.56329 4.53342 6.93024C4.53342 8.29719 5.66102 9.40532 7.05199 9.40532Z","fill":"#50606C","key":1})]);
}

MapMarker.defaultProps = {"width":"15","height":"20","viewBox":"0 0 15 20"};

module.exports = MapMarker;

MapMarker.default = MapMarker;
